import type { Mutable, Prettify } from "@/utils/types/utils"
import { convertEnumTypeToObjType } from "../ts-utils"

/*
export const ORDERS = {
  ASC: "asc",
  DESC: "desc",
} as const

export type Orders = typeof ORDERS
export type Order = Orders[keyof Orders] | undefined

export const SEARCH_PARAMS = {
  SORT_COLUMN: "sortcolumn",
  ORDER: "order",
  SEARCH: "search",
  LAYOUT: "layout",
} as const
export type SearchParams = typeof SEARCH_PARAMS
export type SearchParam = (typeof SEARCH_PARAMS)[keyof typeof SEARCH_PARAMS] | undefined
*/
export const Order = ["asc", "desc"] as const
export type Order = Mutable<string & (typeof Order)[number]>
export const Orders = convertEnumTypeToObjType(Order)

export const SearchParam = [
  // "sortcolumn",
  // "order",
  "search",
  "layout",
  "page",
  "itemsPerPage",
] as const
export type SearchParamsList = Mutable<typeof SearchParam>
export type SearchParam = SearchParamsList[number]
export const SearchParams = convertEnumTypeToObjType(SearchParam)

export type SearchParamsProps<TGetParams extends Record<string, unknown>> = Prettify<{
  [TProp in keyof TGetParams as TGetParams[TProp] extends unknown | undefined
    ? TProp extends `order[${string}]` | "sortcolumn" | "order" | "search" | "page" | "itemsPerPage"
      ? never
      : TProp
    : never]?: TGetParams[TProp]
}>

export type SearchParamsOrderby<TGetParams extends Record<string, unknown>> = Prettify<{
  [TProp in keyof TGetParams as TGetParams[TProp] extends Order | undefined
    ? TProp extends `order[${string}]`
      ? string & TProp
      : never
    : never]?: TGetParams[TProp]
}>

export type FieldsParamsOrderby<TGetParams extends Record<string, unknown>> = Prettify<{
  [TProp in keyof TGetParams as TGetParams[TProp] extends Order | undefined
    ? TProp extends `order[${infer TShort}]`
      ? string & TShort
      : never
    : never]?: TGetParams[TProp]
}>

export type SearchParamProps<TGetParams extends Record<string, unknown>> =
  keyof SearchParamsProps<TGetParams>

export type SearchParamOrderby<TGetParams extends Record<string, unknown>> =
  keyof SearchParamsOrderby<TGetParams>

export type FieldsParamOrderby<TGetParams extends Record<string, unknown>> = Prettify<
  string & keyof FieldsParamsOrderby<TGetParams>
>

export type FilterSingleValue = string | undefined

export type FilterMultiValue = string[]

export const getSortParam = <TGetParams extends Record<string, unknown>>(
  param: FieldsParamOrderby<TGetParams>
) => {
  return `order[${param}]` as SearchParamOrderby<TGetParams>
}
